<div mat-dialog-title class="modal-title">
  <h2>{{ "ONSIP_I18N.DOWNLOAD_DIRECTORY" | translate }}</h2>
</div>
<div mat-dialog-content>
  <mat-form-field appearance="outline" class="form-control" tabindex="-1">
    <mat-select
      [formControl]="formControl"
      [placeholder]="'ONSIP_I18N.CHOOSE_FILE_TYPE' | translate"
    >
      @for (fileType of fileTypes; track fileType) {
      <mat-option [value]="fileType.value">
        {{ fileType.label }}
      </mat-option>
      }
    </mat-select>
    <mat-error>{{ "ONSIP_I18N.PLEASE_SELECT_A_FILE_TYPE" | translate }}</mat-error>
  </mat-form-field>
</div>
<div mat-dialog-actions class="button-container modal-actions">
  <button mat-button color="primary" type="button" (click)="dialogRef.close()">
    {{ "ONSIP_I18N.CANCEL" | translate }}
  </button>
  <button mat-flat-button color="primary" type="button" (click)="submitData()">
    {{ "ONSIP_I18N.DOWNLOAD" | translate | titlecase }}
  </button>
</div>
